// // // src/components/PrivateRoute.js
// import React, { useContext } from 'react';
// import { Navigate } from 'react-router-dom';
// import { AuthContext } from '../context/AuthContext';
// function PrivateRoute({ children }) {
//   const { user, loading } = useContext(AuthContext);
//   // Show a loading spinner while verifying the user
//   if (loading) {
//     return <div>Loading...</div>;
//   }
//   // Redirect to login if the user is not authenticated
//   if (!user) {
//     return <Navigate to="/" />;
//   }
  
//   // Render children if authenticated
//   return children;
// }
// export default PrivateRoute;

// src/components/PrivateRoute.js
import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
function PrivateRoute({ children }) {
  const { user, loading } = useContext(AuthContext);
  if (loading) {
    return <div>Loading...</div>;
  }
  if (!user) {
    return <Navigate to="/" />;
  }
  return children;
}
export default PrivateRoute;
